
document.addEventListener('DOMContentLoaded', function () {
    var Calendar = FullCalendar.Calendar;

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, month, day].join('-');
    }

    /* initialize the calendar
    -----------------------------------------------------------------*/

    var calendarEl = document.getElementById('calendar');
    var calendar = new Calendar(calendarEl, {
        schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        plugins: [
            'interaction',
            'resourceTimeline',
            'resourceTimeGrid',
            'dayGrid',
            'timeGrid',
            'list',
            'moment'

        ],
        allDaySlot: false,
        businessHours: {
            // days of week. an array of zero-based day of week integers (0=Sunday)
            daysOfWeek: [1, 2, 3, 4, 5], // Monday - Thursday

            startTime: '08:00', // a start time (10am in this example)
            endTime: '17:00', // an end time (6pm in this example)
        },
        locale: 'lt',
        header: {
            left: 'prev,next today, resourceTimelineMonth,resourceTimeline5days',
            center: 'title',
                // 'resourceTimelineDay,' +
                // 'resourceTimelineMonth,' +
                // 'resourceTimeline5days ' +
                // 'resourceTimeGridDay,' +
                // 'resourceTimeGridTwoDay ' +
                // '',
            // right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
            right: 'dayGridMonth,listWeek'
        },
        // defaultDate: '2019-06-27',
        // slotDuration: '00:15:00',
        minTime: '08:00:00',
        maxTime: '17:00:00',
        defaultView: 'dayGridMonth',
        aspectRatio: 1.8,
        // defaultView: 'resourceTimelineDay',
        editable: true,
        // droppable: true, // this allows things to be dropped onto the calendar
        // selectable: true,

        // eventClick: function(info) {
        //     console.log('Event: ' + info.event.title);
        //     console.log('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
        //     console.log('View: ' + info.view.type);
        //
        //     // change the border color just for fun
        //     info.el.style.borderColor = 'red';
        // },
        dateClick: function (i) {
            console.log(i);
            // console.log('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
            // console.log('Current view: ' + info.view.type);
            // change the day's background color just for fun
            // info.dayEl.style.backgroundColor = 'red';
            if (confirm('Sukurti naują laiką?')) {
                // alert('open');
                $('#modalTitle').html("Sukurti naują laiką");
                $('#modalBody').html('Nuo: ' + formatDate(new Date(i.dateStr).toLocaleString('lt-LT')))
                    .append('<form class="was-validated" method="GET" action="/add_event">\n' +
                        ' <input type="hidden" name="date" value="' + formatDate(new Date(i.dateStr).toLocaleString('lt-LT')) + '"> ' +
                        '' +
                        // '  <div class="custom-control custom-radio">\n' +
                        // '    <input type="radio" class="custom-control-input" id="pajungimas" name="type" value="work" required>\n' +
                        // '    <label class="custom-control-label" for="pajungimas">Darbas</label>\n' +
                        // '  </div>\n' +
                        // '  <div class="custom-control custom-radio mb-3">\n' +
                        // '    <input type="radio" class="custom-control-input" id="gedimas" name="type" value="issue" required>\n' +
                        // '    <label class="custom-control-label" for="gedimas">Gedimas</label>\n' +
                        // '  </div>' +
                        ' <input type="submit" value="Sukurti"> ' +
                        '</form>')
                    .append('');
                // $('#eventUrl').attr('href',i.event.url);
                $('#calendarModal').modal();
            }
        },
        select: function (info) {
            console.log('selected ' + info.startStr + ' to ' + info.endStr);
        },
        hourClick: function (info) {
            console.log('Clicked on: ' + info.dateStr);
            console.log('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
            console.log('Current view: ' + info.view.type);
            // change the day's background color just for fun
            info.dayEl.style.backgroundColor = 'red';
        },
        eventResize: function (info) {
            console.log('EVENT Resize');
            // console.log(info);
            // console.log('Start: ' + info.event.start.toLocaleString());
            // console.log(FullCalendarMoment.toMoment(info.event.start, calendar));
            // console.log(new Date(info.event.start).toISOString());
            // console.log('Stop: ' + info.event.end.toLocaleString());
            // console.log(new Date(info.event.start).toLocaleString());
            // console.log(new Date(info.event.end).toLocaleString());
            // change the day's background color just for fun
            // info.dayEl.style.backgroundColor = 'red';
            $.ajax({
                url: 'event/add',
                data: 'id=' + info.event.id + '' +
                    '&start=' + new Date(info.event.start).toLocaleString() + '' +
                    '&end=' + new Date(info.event.end).toLocaleString() + '' +
                    // '&new_user_id='+ info.event.newResource.id +
                    '&title=' + info.event.title,
                type: "POST",
                success: function (json) {
                    console.log(this.data);
                    console.log(json);
                },
                error: function (json) {
                    console.log(json);
                }
            });
        },
        // eventClick: function (i, jsEvent, view) {
        //     console.log(i.event);
            // $('#modalTitle').html(i.event.title);
            // $('#modalBody').html(i.event.description);
            // $('#eventUrl').attr('href', i.event.url);
            // jQuery('#calendarModal').modal('show');
            // console.log($);
        // },
        eventDrop: function (info) {
            console.log('EVENT DROP');
            console.log(info.newResource);
            var end = info.event.end;
            if (!end) {
                end = null;
            } else {
                end = new Date(info.event.end).toLocaleString();
            }

            // console.log('fack');
            // console.log(info.event.title);
            // console.log(info.event.end);

            var new_user_id = '';
            if (info.newResource != null) {
                var new_user_id = info.newResource.id;
            }


            $.ajax({
                url: 'event/add',
                data: 'id=' + info.event.id + '' +
                    '&start=' + new Date(info.event.start).toLocaleString() + '' +
                    '&end=' + new Date(end).toLocaleString() + '' +
                    '&new_user_id=' + new_user_id + '' +
                    '&title=' + info.event.title,
                type: "POST",
                success: function (json) {
                    console.log(json);
                },
                error: function (json) {
                    console.log(json);
                }
            });
        },
        eventMouseover: function(event, jsEvent, view) {
            console.log('ov');
            // $('.fc-event-inner', this).append('<div id=\"'+event.id+'\" class=\"hover-end\">'+$.fullCalendar.formatDate(event.end, 'h:mmt')+'</div>');
        },
        // slotWidth: '10',
        groupByResource: true,
        datesAboveResources: true,
        resourceLabelText: 'Darbuotojai',
        resourceGroupField: 'groupId',
        // filterResourcesWithEvents: true,
        views: {
            resourceTimeGridTwoDay: {
                type: 'resourceTimeGrid',
                duration: {days: 2},
                buttonText: '2 dienos'
            },
            resourceTimeline5days: {
                type: 'resourceTimeline',
                duration: {days: 5},
                buttonText: '5 dienos'
            }
        },


        refetchResourcesOnNavigate: true,
        resources: function (fetchInfo, successCallback, failureCallback) {
            // Useriai i kalendoriu
            $.ajax({
                url: '/event_resources',
                // data: 'start=2019-06-28',
                type: "GET",
                success: function (json) {
                    // console.log(json);
                    successCallback(json);
                },
                error: function (json) {
                    console.log(json);
                },

            });
        },



        eventSources: [

            // your event source
            {
                url: '/myevents', // use the `url` property
                color: 'lightgreen',    // an option!
                // textColor: 'whi',  // an option!
                //constraint:  'availableWork2' // an option!
            },
            // your time source
            // {
            //     url: '/mytimes', // use the `url` property
            //     color: 'lightgreen',    // an option!
                // textColor: 'red',  // an option!
                //constraint:  'availableWork2' // an option!
            // }
        ],

    });
    calendar.render();

});